import { Navigate, useParams } from 'react-router-dom';

import { viewportBaseOf } from 'lib/helpers/viewportPath';
import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const OnboardingOverview = withLazyFallback(
  () => import('components/shared/OnboardingOverview/OnboardingOverview')
);
const FacilityTable = withLazyFallback(
  () => import('components/admin/pages/Practices/Facility/FacilityTable')
);
const AdminFormBuilder = withLazyFallback(
  () => import('components/admin/pages/Practices/FormBuilder/AdminFormBuilder')
);
const AdminPracticesTransactions = withLazyFallback(
  () => import('components/admin/pages/Practices/Transaction/Transactions')
);
const OnboardingWizard = withLazyFallback(
  () => import('components/shared/OnboardingWizard/OnboardingWizard')
);

const LegacyRedirect = ({ to }) => {
  const { id } = useParams();
  return <Navigate to={`${viewportBaseOf(id)}/${to}`} replace />;
};

const LEGACY_CHILDREN = [
  {
    path: 'onboarding',
    element: <OnboardingWizard />,
    children: [
      { path: 'overview', element: <OnboardingOverview /> },
      { path: ':step_id', element: <OnboardingWizard /> },
      { path: ':step_id/:substep_id', element: <OnboardingWizard /> }
    ]
  },
  { path: 'form-builder', element: <AdminFormBuilder />, handle: { title: 'Form builder' } },
  { path: 'facility', element: <FacilityTable />, handle: { title: 'Facilities' } },
  {
    path: 'transactions',
    element: <AdminPracticesTransactions />,
    handle: { title: 'Transactions' }
  },
  { path: 'staff', element: <LegacyRedirect to="settings/staff" /> },
  { path: 'staff-management', element: <LegacyRedirect to="settings/staff" /> },
  { path: 'patients', element: <LegacyRedirect to="charts" /> },
  { path: 'terminals', element: <LegacyRedirect to="settings/terminals" /> },
  { path: 'roles', element: <LegacyRedirect to="settings/roles" /> },
  { path: 'billing', element: <LegacyRedirect to="settings/billing" /> },
  { path: 'kiosk', element: <LegacyRedirect to="settings/kiosk" /> },
  { path: 'modules', element: <LegacyRedirect to="settings/modules" /> },
  { path: 'organization', element: <LegacyRedirect to="admin-tools/organization" /> },
  { path: 'patient-import', element: <LegacyRedirect to="admin-tools/patient-import" /> },
  { path: 'forms/*', element: <LegacyRedirect to="settings/forms" /> }
];

export default LEGACY_CHILDREN;
